export const POSTING_VIDEO_DTO_ENUMS = {
  CONTENT_TYPE_CODE: {
    /* 클린본 */
    REELS_RAW: 1,
    /* 원본 */
    REELS_PUBLISHED: 2,
    /* 사전검수 */
    REELS_INSPECTION_INITIAL: 3,
    /* 사전검수 수정 */
    REELS_INSPECTION_FIXED: 4,
  },
  INSPECTION_STATUS: {
    /* 검수대기 */
    PENDING: 0,
    /* 반려 */
    REJECTED: 1,
    /* 승인 */
    APPROVED: 2,
  },
}